
import Vue from 'vue';
import Component from 'vue-class-component';
import BaseLookup from './BaseLookup';
import TLookupSkin from './LookupSkin.vue';

@Component({
  name: 'ListLookup',
  components: {
    TLookupSkin,
  },
})
export default class ListLookup extends BaseLookup {
  dialogVisible = false;

  suggestionControllerName() {
    return 'List';
  }

  keyPrefix() {
    return 'List';
  }

  openDialog() {
    this.dialogVisible = true;
  }

  handleSelect(val) {
    this.addItem({
      key: val.key,
      title: val.value,
    });
  }

  linkClick(listId, row) {
    const item = {
      key: `${this.keyPrefix()}-${listId}`,
      title: row.TITLE.value,
    };

    this.addItem(item);
    if (!this.multipleSelection) {
      this.dialogVisible = false;
    }
  }
}
